import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class FarRedAttribute extends Sensor {
  public farRedChart: any;
  private farRedSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.farRedChart = null;
    this.farRedSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.farRedSensor, position);
      this.farRedSensor[position].push([timestamp, element.farRed]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredFarRed = this.farRedSensor.filter(series => series.length > 0);

    const positionNodeFarRed = this.farRedSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.farRedChart = this.getConfigChar(
      'farRed',
      this.getChartSeriesNewNode('Sensor', filteredFarRed, positionNodeFarRed),
      this.getRanges('farRed'),
      this.getLimits('farRed')
    );
  }

  public hasFarRedSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.farRedSensor.length &&
      this.farRedSensor[index].length > 0
    );
  }

  public getFarRedSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.farRedSensor.length) {
      const sensorData = this.farRedSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Radiación Roja Lejana', value: 'farRed' }
    ];
  }
}
